/**
  * @class meleMap_path
  * @description
  *
  * # Purpose
  * Implaments PATH shape
  *
  * # Use
  *
  * # Implementation notes
  *
  */

import meleMap_shape from '../meleMap_shape.js'
const melemap_lib = require('../meleMap_lib.js')

export default class meleMap_path extends meleMap_shape {
  static shape() { return 'P' }

  update(props, silent) {
    props = this._props = _.isObjectLike(props) ? _.cloneDeep(props) : {}
    const shape = String(props.shape??'').replace(/^\w(,|$)/, '') // strip out shape type
    const points = shape.splitCorrect(',')
    // this._points = points.map(p=>/^[A-Z]$/.test(p)?p:melemap_lib.geohash2point(p))
    this._points = points.filter(p=>!/^[A-Z]$/.test(p)).map(p=>melemap_lib.geohash2point(p))

    let lines = shape.splitCorrect(',P,')
    lines = lines.map(line=>line.splitCorrect(',').map(p=>melemap_lib.geohash2point(p)))
    this._lines = lines

    delete this._center
    this.redraw()
  }

  redrawShape() {
    if(this._points.length<2) { return this.deleteShape() }

    if(this._shape) {
      this._shape.setLatLngs(this._points)
    } else {
      this._shape = L.polyline(this._lines, {
        pane: this._props.pane || melemap_lib.DEFAULT_PANE,
      }).addTo(this._map)
    }

    this.configureShape()
  }

  calculateCenter() {
    if(!Array.isArray(this._lines) || this._lines.length<1) {
      this._center = null
      return this._center
    }

    const centers = this._lines.map(points => {
      if(!Array.isArray(points) || points.length<2) {
        return null
      }else if(points.length===2) {
        return melemap_lib.intermediatePoint(points[0], points[1], 0.5)
      }else {
        // calculate lengths of all polyline segments
        const lengths = []
        let total = 0
        for(let i=1; i<points.length; i++) {
          const length = L.latLng(points[i-1]).distanceTo(points[i])
          lengths.push(length)
          total += length
        }

        if(total<=0) {
          return points[0]
        }

        // remove segments until we reach the one that is longer than remaining mid length, i.e. one that contains the midpoint
        let mid = total/2
        while(mid>0 && lengths.length>0) {
          if(lengths[0]>mid) break
          mid -= lengths.shift()
        }
        if(lengths.length===0 || lengths[0]<=0) {
          return points[0]
        }

        const lat1 = points[points.length - lengths.length - 1] // start point of segment containing midpoint
        const lat2 = points[points.length - lengths.length] // end point of segment containing midpoint

        return melemap_lib.intermediatePoint(lat1, lat2, mid / lengths[0])
      }
    }).filter(center=>center)

    if(centers.length===0) {
      this._center = null
      return this._center
    }else if(centers.length<3) {
      this._center = centers[0]
      return this._center
    }

    // calcuate centroid
    const centroid = [0, 0]
    for(const pt of centers) {
      const [lat, lng] = pt
      centroid[0] += lat
      centroid[1] += lng
    }
    centroid[0] /= centers.length
    centroid[1] /= centers.length

    // calculate distance from centroid to all points
    const distances = centers.map(pt=>L.latLng(pt).distanceTo(centroid))
    const center = centers[distances.indexOf(Math.min(...distances))]
    this._center = center
    return center
  } // calculateCenter

  shape() {
    return 'P,'+this._points.map(point=>melemap_lib.point2geohash(point)).join(',')
  }

  addPoint(point) {
    this._points.push(point)
    delete this._center
    this.redrawShape()
    this.redrawMarker()

    // prepare guiding line
    const last_point = this._points[this._points.length-1]
    if(this._guide) {
      this._guide.setLatLngs([last_point, last_point])
    }else {
      this._guide = L.polyline([last_point, last_point], { pane: melemap_lib.DRAW_PANE }).addTo(this._map)
    }
    this._guide._path.setAttribute('marker', 'guide')
  }

  guide(point) {
    if(this._guide) {
      const last_point = this._points[this._points.length-1]
      if(!point) point = last_point
      this._guide.setLatLngs([last_point, point])
    }
  }
} // class meleMap_path
